import { UserButton as ClerkUserButton, useUser } from '@clerk/clerk-react';

interface UserButtonProps {
  showName?: boolean;
}

export function UserButton({ showName = false }: UserButtonProps) {
  const { user } = useUser();

  return (
    <div className="flex items-center gap-3">
      {showName && user && (
        <div className="text-right hidden sm:block">
          <p className="text-sm font-medium text-gray-700">
            {user.firstName || user.emailAddresses[0]?.emailAddress?.split('@')[0]}
          </p>
          <p className="text-xs text-gray-500">
            {user.emailAddresses[0]?.emailAddress}
          </p>
        </div>
      )}
      <ClerkUserButton
        appearance={{
          elements: {
            avatarBox: 'w-9 h-9',
            userButtonPopoverCard: 'shadow-xl rounded-xl border border-gray-100',
            userButtonPopoverActionButton: 'hover:bg-gray-50',
            userButtonPopoverActionButtonText: 'text-gray-700',
            userButtonPopoverFooter: 'hidden',
          },
        }}
        afterSignOutUrl="/sign-in"
      />
    </div>
  );
}
